import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callSystemSettingList = async (settingGroup) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/system-setting/${settingGroup}?isfrontview=true&isuse=true`));
};